import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { PreferenceService } from '../../services/preference.service';

@Pipe({
  name: 'area',
})
export default class AreaPipe implements PipeTransform {
  constructor(private preferenceService: PreferenceService) {}

  transform(value: number, format: string, decimals: number = 2, unit: boolean): string {
    if (!value) return 'N/A';
    let transformValue: number;

    if (format === 'meters') {
      transformValue = Number(value.toFixed(decimals));
    } else if (format === 'kilometers') {
      transformValue = Number((value / 1000000).toFixed(decimals));
      if (transformValue === 0) {
        transformValue = Number(value.toFixed(decimals));
      }
    } else {
      return value.toString();
    }

    const formattedValue = formatNumber(transformValue, this.preferenceService.$currentLang());
    const unitLabel = format === 'kilometers' && transformValue !== 0 ? ' km²' : ' m²';

    return unit ? formattedValue + unitLabel : formattedValue;
  }
}
